import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, PRICE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-oportunidad" className="bg-navy" data-id="element-55" data-mp="c8c21b44epg7">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-56" data-mp="84xk2ewmfz04">
        <Reveal data-id="element-57" data-mp="m4ow4a3kv5bh">
          <h2 id="ultima-oportunidad" className="font-display text-lg font-black uppercase leading-tight text-gold sm:text-2xl" data-id="element-58" data-mp="m46nedzqaymo">
            Una última oportunidad
          </h2>
          <p className="mx-auto mt-1 max-w-xl text-[0.78rem] leading-snug text-ivory sm:text-[0.9rem]" data-id="element-59" data-mp="vtqbby2atioe">
            Puedes seguir guardando videos, descargando aplicaciones y
            preguntándote qué deberías aprender primero.{' '}
            <span className="font-bold text-white" data-id="element-60" data-mp="14td8g7nzw2bn">
              O puedes comenzar hoy a construir tus bases de inglés siguiendo
              una ruta desde cero.
            </span>
          </p>
          <p className="mt-1 font-script text-2xl leading-tight text-gold sm:text-3xl" data-id="element-61" data-mp="2c6rbsam3yip6">
            No necesitas saber inglés para empezar. Necesitas dar el primer
            paso.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-3 rounded-xl border-2 border-gold bg-navy-deep p-3 sm:p-5" data-id="element-62" data-mp="2r1xgmu9gwbgx">
          <h3 className="font-display text-base font-black uppercase leading-tight text-gold sm:text-xl" data-id="element-63" data-mp="2v4ak1c0qrxaj">
            📘 {PRODUCT}
          </h3>
          <p className="font-sans text-[0.92rem] font-extrabold uppercase text-white sm:text-lg" data-id="element-64" data-mp="300iuwd7wp4bw">
            6 Módulos + 5 Bonos
          </p>
          <p className="mt-1.5 text-[0.68rem] font-bold uppercase text-ivory sm:text-[0.78rem]" data-id="element-65" data-mp="39sych9fajqw9">
            Valor de los bonos:{' '}
            <span className="line-through decoration-danger decoration-2" data-id="element-66" data-mp="3et2ux4zrevp4">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="mt-1 text-[0.62rem] font-bold uppercase tracking-[0.24em] text-ivory sm:text-[0.7rem]" data-id="element-67" data-mp="3iqqwurzvdoqi">
            Hoy:
          </p>
          <p className="font-display text-4xl font-black leading-none text-gold sm:text-5xl" data-id="element-68" data-mp="1eqbghxg0d8n6">
            {PRICE}
          </p>

          <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-69" data-mp="1shybzv24md4w">
            <CtaButton size="lg" data-id="element-70" data-mp="1novs6en5ii1w">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.64rem] font-bold uppercase tracking-wide text-ivory sm:text-[0.72rem]" data-id="element-71" data-mp="22ekx8kyd767g">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-72" data-mp="2bfj0h10zb9oz">•</span>
              Entrega Digital
              <span aria-hidden="true" data-id="element-73" data-mp="2bdezorydmqsx">•</span>
              <span className="flex items-center gap-1" data-id="element-74" data-mp="27do2a5echcff">
                <ShieldCheckIcon size={12} className="text-gold" data-id="element-75" data-mp="27c37qfs15thk" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}